import  React from 'react';
import _ from "lodash";
import Button from "../button";
import '../../style/dots.css';
import Dots from 'react-activity/lib/Dots';

const ArticleDeleteModal = (props) => {
    let selectedArticles = props.findArticles();
    return (
        <div className="col-sm-12">
            <div className="row">
                <div className="col-sm-12">
                    <span>Are you sure you want to delete the selected articles?</span>
                </div>
            </div>
            <div className="row">
                <div className="col-sm-12">
                    <ul>
                        {
                            _.map(selectedArticles, (article, index) => {
                                return <li key={index}>
                                        {article.title}
                                </li>
                            })
                        }
                    </ul>
                </div>
            </div>
            <div className="row">
                <div className="col-sm-12">
                    {
                        selectedArticles.length > 0 && (props.deleting)?
                            <div className="">
                                <div className="col-sm-3"></div>
                                <div className="col-sm-6">
                                    <div className="col-sm-5"></div>
                                    <Dots/>
                                </div>
                            </div>
                            :
                            null
                    }
                </div>
            </div>
            <Button
                clickHandler={() => props.handleDelete()}
                wrapper="btn-wrapper"
                btnType="button" btnStyle={'btn btn-primary btn-xs sharp yellow'}
                label="Confirm"/>
            <Button
                clickHandler={() => props.changeArticlesListSettings('deleteModal', false)}
                wrapper="btn-wrapper"
                btnType="button" btnStyle={'btn btn-primary btn-xs sharp white'}
                label="Cancel"/>
        </div>
    )
};

export default ArticleDeleteModal;